module.exports = {"expand":"Expand","hide":"Collapse","up":"Up","down":"Down","navigationTitle":"Navigation"}